import merge from 'lodash-es/merge';
import getDefaultStyle from '../css/defaultStyle';

export function getDefaultControlStyle(instance) {
  if (!getDefaultControlStyle[instance.args.designMode]) {
    getDefaultControlStyle[instance.args.designMode] = {
      url: 'themes/css/img/icon-placeholder.png',
      normal: merge({}, getDefaultStyle(), {
        position: 'absolute',
        transitionProperty: 'all',
        transitionDuration: '${schemeAnimationDuration}',
        transitionTimingFunction: 'ease',
        transitionDelay: '0s',
        top: '8px',
        left: '8px',
        width: '48px',
        height: '40px',
        margin: '0px',
        display: 'inline-block',
        userSelect: 'none',
      }),
      body: {
        normal: merge({}, getDefaultStyle(), {
          transitionProperty: 'all',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          boxSizing: 'border-box',
          padding: '0px',
          display: 'block',
          position: 'absolute',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
          width: '100%',
          height: '100%',
          margin: '0px',
        }),
        hover: {},
      },
      hover: {},
    };
  }

  return getDefaultControlStyle[instance.args.designMode];
}

export function getDefaultControl() {
  if (!getDefaultControl.source) {
    getDefaultControl.source = document.createElement('div');
    getDefaultControl.source.classList.add('controls');
    getDefaultControl.source.innerHTML = '<img class="body" draggable="false">';
  }

  return getDefaultControl.source.cloneNode(true);
}
